import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[rlElementOverflowListener]',
})
export class ElementOverflowListenerDirective {
  @Input() elementSelector: string;
  @Output() elementTruncated = new EventEmitter<boolean>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('mouseover') mouseOver() {
    const elementHavingText = this.elementRef.nativeElement.querySelector(
      this.elementSelector,
    );

    if (!elementHavingText) {
      return;
    }

    if (elementHavingText.scrollWidth > elementHavingText.clientWidth) {
      this.elementTruncated.emit(true);
    } else {
      this.elementTruncated.emit(false);
    }
  }
}
